export default function getLayoutContent (content, layout) {
  for (let i = 0; i < content?.length; i++) {
    if (content[i].layout === layout) {
      return content[i]
    }
  }
  return ''
}
